_collow.components.StepPanelWrapper = class StepPanelWrapper extends (
    _collow.components.Base
  ) {
    root;
    elements;
    params;
    menuButtons;
    contentSections;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.menuButtons = document.querySelectorAll('.step-panel__sidebar li');
      this.contentSections = document.querySelectorAll('.content-section');

      this.showSection({ detail: { step: 1} });

      this.listen(document, "_fill-step-circle", this.toogleStepCircle);
      this.listen(document, "_show-next-step", this.showSection);
      this.listen(document, "_show-prev-step", this.showSection);

    }

    showSection = ({detail}) => {
      const { step } = detail
      this.contentSections.forEach(sections => sections.setAttribute("active", "false"));
      document.querySelectorAll(".step-panel__sidebar li").forEach(li => li.setAttribute("active", "false"));

      const selectedSection = document.querySelector(`.content-section[step-number="step-${step}"]`);
      const selectedStep = document.querySelector(`.step-panel__sidebar li[step-number="step-${step}"]`);
      if (selectedSection) {
          selectedSection.setAttribute("active", "true")
          selectedStep.setAttribute("active", "true")
          this.dispatch(this.root, "_update-step-info", {step: step, isActive: "true"});
      }
    }

    toogleStepCircle = ({detail}) => {
      const { step, completed } = detail
      const stepMenu = document.querySelector(`[step-number="step-${step}"]`)
      
      stepMenu.setAttribute("step-completed", completed)
    }
};
  
   
  
  
  
  
  
  